import { useTranslation } from "react-i18next";

/**
 * Nói ra những chứng từ KHÔNG được tính vào con số đang hiển thị.
 *
 * Ba màn hình tổng hợp (Dashboard, Phân tích, Lợi nhuận) đều chỉ cộng chứng từ
 * cùng một loại tiền — cộng 100 USD với 100 HKD không ra 200 của bất cứ thứ gì.
 * Nhưng lặng lẽ bỏ bớt còn tệ hơn cộng sai: người đọc tưởng mình đang nhìn toàn
 * cảnh. Rỗng thì không hiện gì.
 */
export function CurrencyNotice({
  excluded,
  className,
}: {
  excluded: { currency: string; count: number }[];
  className?: string;
}) {
  const { t } = useTranslation();
  if (!excluded.length) return null;
  return (
    <div
      className={
        "mt-3 rounded-sm border border-[color:var(--color-warn)]/30 bg-warn-tint px-3 py-2 text-xs text-ink-soft " +
        (className ?? "")
      }
    >
      {excluded.map((c) => (
        <span key={c.currency} className="mr-3">
          {t("dashboard.currencyExcluded", { count: c.count, currency: c.currency })}
        </span>
      ))}
    </div>
  );
}
